export default [
	{
		navKey:'usa',
		navName:'美国',
		data: [
			{
				category:'美本',
				list:[
					{text:'本科教育体制',link:'/usa'},
					{text:'藤校直通车',link:'/usa'},
					{text:'美国TOP30保录',link:'/usa'},
					{text:'本科热门专业介绍',link:'/usa'},
					{text:'综合大学排名',link:'/usa'},
					{text:'文理学院排名',link:'/usa'},
					{text:'申请指南',link:'/usa'},
					{text:'转学申请',link:'/usa'},
					{text:'美国生活防坑指南',link:'/usa'},
					{text:'费用详解',link:'/usa'},
					{text:'留学签证',link:'/usa'},
					{text:'案例展示',link:'/usa'},
				]
			},
			{
				category:'美研',
				list:[
					{text:'硕士热门专业介绍',link:'/usa'},
					{text:'大学排名',link:'/usa'},
					{text:'申请规划',link:'/usa'},
					{text:'奖学金',link:'/usa'},
					{text:'美国生活防坑指南',link:'/usa'},
					{text:'费用详解',link:'/usa'},
					{text:'留学签证',link:'/usa'},
					{text:'工作签证',link:'/usa'},
					{text:'案例展示',link:'/usa'},
				]
			},
		]
	},
	{
		navKey:'england',
		navName:'英国',
		data: [
			{
				category:'英国',
				list:[
					{text:'英国教育体制',link:'/uk'},
					{text:'英国Times排名',link:'/uk'},
					{text:'英国十大优势专业',link:'/uk'},
					{text:'G5申请',link:'/uk'},
					{text:'留学英国途径',link:'/uk'},
					{text:'英国留学费用',link:'/uk'},
					{text:'案例介绍',link:'/uk'},
				]
			}
		]
	},
	{
		navKey:'canada',
		navName:'加拿大',
		data: [
			{
				category:'加拿大',
				list:[
					{text:'加拿大院校介绍',link:'/canada'},
					{text:'加拿大学校排名',link:'/canada'},
					{text:'加拿大留学优势',link:'/canada'},
					{text:'移民',link:'/canada'},
				]
			}
		]
	},
	{
		navKey:'europe',
		navName:'欧洲',
		data: [
			{
				category:'德国',
				list:[
					{text:'德国留学优势',link:'/europe'},
					{text:'德国留学方案',link:'/europe'},
					{text:'德国大学介绍',link:'/europe'},
				]
			},
			{
				category:'法国',
				list:[
					{text:'法国留学优势',link:'/europe'},
					{text:'法国留学方案',link:'/europe'},
					{text:'法国大学介绍',link:'/europe'},
				]
			},
			{
				category:'意大利',
				list:[
					{text:'意大利留学优势',link:'/europe'},
					{text:'意大利留学方案',link:'/europe'},
					{text:'意大利大学介绍',link:'/europe'},
				]
			},
		]
	},
	{
		navKey:'asia',
		navName:'亚洲',
		data: [
			{
				category:'中国香港',
				list:[
					{text:'中国香港院校资讯',link:'/hongkong'},
					{text:'中国香港留学案例',link:'/hongkong'},
					{text:'中国香港专业解析',link:'/hongkong'},
					{text:'中国香港留学费用 ',link:'/hongkong'},
				]
			},
			{
				category:'新加坡',
				list:[
					{text:'新加披名校保录',link:'/singapore'},
					{text:'新加坡留学优势',link:'/singapore'},
					{text:'新加坡选校攻略',link:'/singapore'},
					{text:'新加坡行前指导',link:'/singapore'},
				]
			},
			{
				category:'日本',
				list:[
					{text:'日本选校攻略',link:'/japan'},
					{text:'日本留学优势',link:'/japan'},
					{text:'日本申请规划',link:'/japan'},
					{text:'日本行前指导',link:'/japan'},
				]
			},
			{
				category:'韩国',
				list:[
					{text:'韩国院校百度',link:'/korea'},
					{text:'韩国留学优势',link:'/korea'},
					{text:'韩国案例分享',link:'/korea'},
					{text:'韩国省钱攻略',link:'/korea'},
				]
			},
			{
				category:'马来西亚',
				list:[
					{text:'马来西亚难点解析',link:'/malaysia'},
					{text:'马来西亚备考咨询',link:'/malaysia'},
					{text:'马来西亚热门院校',link:'/malaysia'},
					{text:'马来西亚本硕选校',link:'/malaysia'},
				]
			},
		]
	},
	{
		navKey:'australia',
		navName:'大洋洲',
		data: [
			{
				category:'澳大利亚',
				list:[
					{text:'澳大利亚院校百科',link:'/australia'},
					{text:'澳大利亚热门专业',link:'/australia'},
					{text:'澳大利亚移民政策',link:'/australia'},
					{text:'澳大利亚申请规划',link:'/australia'},
				]
			},
			{
				category:'新西兰',
				list:[
					{text:'新西兰院校百科',link:'/newzealand'},
					{text:'新西兰就业指导',link:'/newzealand'},
					{text:'新西兰省钱攻略',link:'/newzealand'},
					{text:'新西兰备考咨询',link:'/newzealand'},
				]
			}
		]
	},
]